import { isValidDate } from '@/modules/results/helpers';

interface MatchDurationProps {
  date: string;
  value: string | undefined;
  text: string | undefined;
  start: string | undefined;
  end: string | undefined;
  info: {
    team_one_seed: number;
    team_two_seed: number;
    team_one_winning_percentage: number;
    match_status: number;
  };
  activeTab: string;
}

function MatchDuration({
  date = '',
  value = '',
  text = '',
  start = '',
  end = '',
  info,
  activeTab,
}: MatchDurationProps) {
  // const getTeamTwoPerc = () => {
  // 	return 100 - info.team_one_winning_percentage;
  // };

  // function formatPercentage(value: number) {
  // 	if (typeof value !== 'number') {
  // 		return null;
  // 	}

  // 	let percentage = value.toFixed(2) + '%';
  // 	percentage = percentage.replace(/\.00%$/, '%');
  // 	percentage = percentage.replace(/(\.\d)0%$/, '$1%');

  // 	return percentage;
  // }

  const isValidString = (str: string) => {
    return typeof str === 'string' && str.trim() !== '' && str !== 'Invalid date';
  };

  const isValid = isValidDate(start) || isValidString(start);
  const isValidDt = isValidDate(date) || isValidString(date);

  return (
    <div className='flex flex-wrap items-center justify-center border-b  py-3 sm:flex-nowrap'>
      {/* <div className="order-2 flex w-1/2 flex-col p-2 text-sm sm:order-1 sm:w-1/3 sm:p-0">
				<div>
					<span>{formatPercentage(info.team_one_winning_percentage)}</span>
				</div>
			</div> */}
      {info.match_status === 4 ? (
        <div className='order-1 flex w-full flex-col sm:order-2 sm:w-1/3'>
          {isValidDt ? (
            <div className='font-bold'>
              <span>{date}</span>
            </div>
          ) : null}
          <div className='font-bold'>
            <span>{text}</span>
          </div>
          <div className='text-sm'>
            <span>{value !== '0' ? value : ''}</span>
          </div>
          <div className='text-sm'>
            <span>
              {start !== '0' ? start : ''} - {end !== '0' ? end : ''}
            </span>
          </div>
        </div>
      ) : info.match_status === 2 ? (
        <div className='order-1 flex w-full flex-col items-center gap-1 sm:order-2 sm:w-1/3'>
          {activeTab === 'Match' ? (
            <span className='text-sm'>Match Started</span>
          ) : (
            <span className='text-sm'>Game Started</span>
          )}
          {isValid ? <span className=''>{start}</span> : null}
        </div>
      ) : null}
      {/* <div className="order-2 flex w-1/2 flex-col px-3 text-sm sm:order-3 sm:w-1/3 sm:p-0">
				<div>
					<span>{formatPercentage(getTeamTwoPerc())}</span>
				</div>
			</div> */}
    </div>
  );
}

export default MatchDuration;
